import { setCookie, hasCookie, getCookie, deleteCookie } from 'common-js/cooke-util';

const pageContext = $('meta[name=context-path]').attr('content');
const CSRF = $('meta[name="csrf-token"]').attr('content');

$(() => {
    const cartIcon = document.querySelectorAll('.g-cart-icon');
    const cartIconCase = document.querySelector('.g-cart-icon-case');
    const cartIconBook = document.querySelectorAll('.g-cart-icon-book');
    const cartIconStick = document.querySelectorAll('.g-cart-icon-book-stick');
    const addCartIconBtn = document.querySelectorAll('.js--add-to-cart');
    const cartQuantity = document.querySelectorAll('.js--cart-quantity');
    const cartMenu = document.querySelectorAll('.js--cart-menu');

    /**
     *
     * Cart Animation
     * @param {any} e
     * @returns
     */
    function animationCart() {
        const cartTL = new TimelineLite();

        cartTL
            .set(cartIcon, {x: 0})
            .to(cartIcon, 0.1, {x: '+=60', ease: Bounce.easeOut})
            .to(cartIcon, 0.1, {x: '-=60', ease: Bounce.easeOut})
            .to(cartIcon, 0.1, {x: '+=60', ease: Bounce.easeOut})
            .to(cartIcon, 0.1, {x: '-=60', ease: Bounce.easeOut})
            .to(cartIcon, 0.1, {x: '+=60', ease: Bounce.easeOut})
            .to(cartIcon, 0.1, {x: '-=60', ease: Bounce.easeOut})
            .staggerTo(cartIconBook, 0.1, {autoAlpha: 1})
            .fromTo(cartQuantity, 0.5,
                {autoAlpha: 0, scale: 0},
                {autoAlpha: 1, scale: 1, ease: Bounce.easeOut}, '-=0.5')
            .fromTo(cartIconStick, 0.5, {autoAlpha: 0}, {autoAlpha: 1}, '-=0.3')
        ;

        return cartTL;
    }

    function interactionCartBtn(element) {
        if(element.hasClass("js--cart-from-search-bar")){
            element.text('Added');
        }else{
            element.text('Added to Cart');
        }
        element.addClass('active');
    }

    $(document).on('click', '.js--add-to-cart', function (event) {
        const productId = $(this).attr('product-id');
        const productOrderType = $(this).attr('product-order-type');
        var quantity = $('#js--details-quantity').val();

        if (quantity === undefined) {
            quantity = '1';
        }

        event.stopImmediatePropagation();
        event.stopPropagation();
        event.preventDefault();
        addToCartCall(productId, quantity, productOrderType);
        animationCart();
        interactionCartBtn($(this));

        try {
            fbq('track', 'AddToCart', {
                content_ids: productId,
                content_type: 'product'
            });
        } catch (error) {
        }
    });

    $(document).on('click', '.js--cart-minus-retailer, .js--cart-plus-retailer', function (event) {
        const productId = $(this).attr('product-id');
        var quantity = $('#js--details-quantity-'+productId).val();
        if (quantity === undefined) {
            quantity = '1';
        }

        event.stopPropagation();
        event.preventDefault();
        updateQuantity(productId, quantity);
        animationCart();

        try {
            fbq('track', 'AddToCart', {
                content_ids: productId,
                content_type: 'product'
            });
        } catch (error) {
        }
    });

    $(document).on('click', '.js--add-to-cart-retailer', function (event) {
        const productId = $(this).attr('product-id');
        var quantity = $('#js--details-quantity-'+productId).val();
        if (quantity === undefined) {
            quantity = '1';
        }

        event.stopImmediatePropagation();
        event.stopPropagation();
        event.preventDefault();
        addToCartCall(productId, quantity);
        animationCart();

        try {
            fbq('track', 'AddToCart', {
                content_ids: productId,
                content_type: 'product'
            });
        } catch (error) {
        }
    });

    $(document).on('change blur', '.js--cart-value', function (event) {
        const productId = $(this).attr('product-id');
        var quantity = $('#js--details-quantity-'+productId).val();
        if (quantity === undefined) {
            quantity = '1';
        }

        event.stopPropagation();
        event.preventDefault();
        addToCartCall(productId, quantity);
        animationCart();

        try {
            fbq('track', 'AddToCart', {
                content_ids: productId,
                content_type: 'product'
            });
        } catch (error) {
        }
    });

    //Hide Cart Quantity
    const showTL = new TimelineLite();

    if (Number(cartQuantity[0].textContent) > 0) {
        showTL
            .set(cartIconBook, {autoAlpha: 1})
            .set(cartIconStick, {autoAlpha: 1})
            .set(cartQuantity, {autoAlpha: 1})
    }
});

async function updateQuantity(productId, quantity) {
     $.ajax({
        type: 'POST',
        url: '/cart/change-quantity',
        data: 'productId=' + productId + '&quantity=' + quantity + '&_tk=' + $('meta[name="csrf-token"]').attr('content'),
        success: function (response) {},
        error: function (error) {
            console.log('failed to change quantity');
        },
        complete: function () {}
    });
}

export async function addToCartCall(productId, quantity, orderType) {
    let productOrderType = orderType == null || orderType == '' ? 'NORMAL' : orderType;
    $.ajax({
        type: 'POST',
        url: '/byajax',
        data: 'pid=' + productId + '&qty=' + quantity + '&_tk=' + CSRF,
        success: function (response) {
            if (response.startsWith("preorder-error")) {
                $('.js--preorder-error__body p').text('"আমরা দুঃখিত, একের অধিক প্রি-অর্ডারের পণ্য একসাথে অর্ডার করা সম্ভব হচ্ছে না। আপনি চাইলে প্রি-অর্ডার পণ্যের সাথে স্টকে থাকা অন্য কোন পণ্য যুক্ত করতে পারেন।"');
                $('#js--preorder-error-popup').fadeIn();
                $('.overlay').show();
            } else {
                let result = response.split("|");
                if (result[0] == "true" && result.length > 2) {
                  $('.js--cart-quantity').text(result[1]);
                  if(location.pathname == "/cart/new"){
                    location.reload()
                  }
                }
            }
        },
        error: function (error) {
            console.log('sync request failed');
        },
        complete: function () {}
    });
}
